import { getBaseApi } from "../BaseApi";
import { buildUrl } from "../utils";

export function getStockTransfers(params: {
  limit: number;
  skip: number;
  status?: string;
  fromCountry?: string;
  toCountry?: string;
  keyword?: string;
}) {
  return getBaseApi().get(buildUrl("stock-transfers", params));
}

export function getStockTransfer(id: string) {
  return getBaseApi().get(`stock-transfers/${id}`);
}

export function createStockTransferApi(data: {
  fromProduct: string;
  toCountry: string;
  quantity: number;
  reason?: string;
  notes?: string;
  transporterName?: string;
  trackingNumber?: string;
  toProduct?: string;
}) {
  return getBaseApi().post("stock-transfers", data);
}

export function shipStockTransferApi(
  id: string,
  data?: { trackingNumber?: string; transporterName?: string; notes?: string }
) {
  return getBaseApi().post(`stock-transfers/${id}/ship`, data || {});
}

export function receiveStockTransferApi(id: string, data?: { notes?: string }) {
  return getBaseApi().post(`stock-transfers/${id}/receive`, data || {});
}

export function cancelStockTransferApi(id: string, data?: { reason?: string }) {
  return getBaseApi().post(`stock-transfers/${id}/cancel`, data || {});
}

export function deleteStockTransferApi(id: string) {
  return getBaseApi().delete(`stock-transfers/${id}`);
}
